export default __webpack_public_path__ + "static/media/edit_talent_profile.5feb6099.svg";